import { Box, Typography, useTheme } from '@mui/material';
import { stepperStyles } from '../../styles';

const ConfirmationInfoItem: React.FC<{
  title: string;
  content?: string | React.ReactNode | React.ReactNode[];
}> = ({ title, content }) => {
  const theme = useTheme();
  return (
    <Box sx={stepperStyles.infoItem(theme)}>
      <Typography variant="h6" sx={stepperStyles.infoLabel(theme)}>
        {title}
      </Typography>
      {Array.isArray(content) ? (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
          {content.map((item, idx) => (
            <span key={idx}>{item}</span>
          ))}
        </Box>
      ) : (
        <Typography
          variant="body2"
          sx={stepperStyles.infoValue(theme)}
          component="div"
        >
          {content}
        </Typography>
      )}
    </Box>
  );
};

export default ConfirmationInfoItem;
